// The Library's portal cards (Adam, 10 Oct): a product still on its own site that the person has an
// account for there, from hub.my_elsewhere's rows (the catalogue's own facts), each opening that site
// (config/productPaths.js siteFor) in a new tab. Pure, so a test can import it (library.spec.js);
// library/model.js puts the cards after the hub's own In progress tiles.
import { siteFor } from '../config/productPaths.js'
import { accentKey, artKind, kindLine } from './looks.js'

// A portal card: a product still on its own site, from hub.my_elsewhere's row (the catalogue's own
// facts), in its own look as the Main board draws its tile, with the site it opens as its line. No
// progress: the hub holds none of it. Null when the build has no site for its path.
export function portalTile(row) {
  const href = siteFor(row.path)
  if (!href) return null
  return {
    id: row.product_id, href, external: true, name: row.name, art: artKind(row), accent: accentKey(row.look, row.type),
    cohortLabel: null, cover: null, kind: kindLine(row), status: `On ${new URL(href).host}`, strong: false,
    pct: null, pctLabel: null, locked: null, soon: false, soonAt: null, lastOpened: null,
  }
}

// The portal cards, in the catalogue's order, leaving out anything the hub already draws a tile for
export function portalTiles(rows, owned) {
  const seen = new Set()
  return [...(rows || [])]
    .filter(r => r && r.product_id && !owned.has(r.product_id))
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0) || String(a.product_id).localeCompare(String(b.product_id)))
    .map(portalTile)
    .filter(t => t && !seen.has(t.id) && seen.add(t.id))
}
